export default "//static.tradera.net/touchweb/static/output/images/tradera-circle.react.25b6d837.svg";